import { ILanguage, boStyle } from 'constants/content.constants';
import { Section } from './Section/index';
import { Divider, Stack, useTheme } from '@mui/material';
import { RadioButtonList } from './RadioButtonMenu';
import { useAppSelector } from 'hooks/redux.hooks';
import { getLanguages } from 'state/reducers/content.reducers';
import { useState } from 'react';

interface IProps {
	page: any;
}

export const PageContent = ({ page }: IProps) => {
	const languages = useAppSelector(getLanguages);
	const [selectedLanguage, setSelectedLanguage] = useState(languages[0]?.code || 'he');
	const theme = useTheme();

	const handleChangeLanguage = (event: any) => {
		setSelectedLanguage(event.target.value);
	};

	return (
		<Stack spacing={4}>
			{page?.boStyle === boStyle.SINGLE_LANGUAGE_PAGE && (
				<RadioButtonList
					options={languages?.map((language: ILanguage) => {
						return { value: language.code, label: language.name };
					})}
					selected={selectedLanguage}
					handleChange={handleChangeLanguage}
				/>
			)}
			<Stack
				spacing={5}
				divider={
					<Divider
						orientation="horizontal"
						flexItem
						sx={{ borderBottom: 1, borderColor: theme.palette.root.divider }}
					/>
				}
			>
				{page?.sections?.map((section: any) => {
					return (
						<Section
							key={section.id}
							section={section}
							style={page.boStyle}
							selectedLanguage={selectedLanguage}
						/>
					);
				})}
			</Stack>
		</Stack>
	);
};
